import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { IExportEditJob, IVideoEditTake } from '../../../../../models/project/edit/edit-model';
import { ITranscriptSentence } from '../../../../../models/project/take/transcript-model';
import { TranslateLanguageCodeEnum } from '../../../../../models/language/language-utils-model';
import { EditStyleApiService } from '../../../../../services/api/auth/projects/edit/edit-style-api.service';
import { handleApiCallAsync } from '../../../../../utils/general-functions';
export interface ICurrentSubtitleEdit {
    subtitle: ITranscriptSentence;
    sceneId: string;
}
@Injectable({
    providedIn: 'root',
})
export class EditRoomStateService {
    markerPosition$ = new BehaviorSubject<number>(0);
    currentTime$ = new BehaviorSubject<number>(0);
    private _currentEditJob$ = new BehaviorSubject<IExportEditJob>(null);
    public currentEditJob$ = this._currentEditJob$.asObservable();
    private _currentEditedSubtitle$ = new BehaviorSubject<ICurrentSubtitleEdit>(null);
    public currentEditedSubtitle$ = this._currentEditedSubtitle$.asObservable();
    public subtitleChanged$ = new Subject<void>();

    // runMarker$ = new BehaviorSubject<boolean>(false);
    videosOnTrack$ = new BehaviorSubject<IVideoEditTake[]>([]);
    constructor(private editStyleApiService: EditStyleApiService) {}

    setCurrentEditJob(editJob: IExportEditJob) {
        this._currentEditJob$.next(editJob);
    }

    /**
     * Triggers subtitle changed to let anyone who uses it to re-render or do anything else
     */
    changeSubtitle(): void {
        this.subtitleChanged$.next();
    }

    changeSubtitleLanguage(language: TranslateLanguageCodeEnum) {
        const currentEdit = this._currentEditJob$.getValue();
        if (!currentEdit) {
            return;
        }
        currentEdit.chosenTranscriptLanguage = language;
        this.setCurrentEditJob(currentEdit);
    }
    async changeSubtitleAlignmentAsync(projectId: string, editId: string, alignmentValue: number) {
        const currentEdit = this._currentEditJob$.getValue();
        currentEdit.plugins.subtitles.settings[0].style.MarginV = alignmentValue.toString();
        currentEdit.plugins.subtitles.settings[1].style.MarginV = alignmentValue.toString();
        this.setCurrentEditJob(currentEdit);
        const { data, error } = await handleApiCallAsync(
            this.editStyleApiService.updateSubtitleAlignment$(projectId, editId, alignmentValue.toString())
        );
    }
    subtitleFocused(subtitle: ICurrentSubtitleEdit) {
        this._currentEditedSubtitle$.next(subtitle);
    }
    get currentEditedSubtitle(): ICurrentSubtitleEdit {
        return this._currentEditedSubtitle$.getValue();
    }
}
